export default "__VITE_ASSET__650c70aa__"